import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-modal'

import {
  deleteNewStudentAction,
  setClassroomAction,
  setCourseAction,
  setSchoolAction,
  setStepAction,
  steps,
} from '../../store/actions/student.actions'
import ClassroomForm from './ClassroomForm'
import CourseForm from './CourseForm'
import StudentAddForm from 'components/StudentAddForm'
import ModalSchoolCodeStudent from 'components/ModalSchoolCodeStudent'
import { useSnackBarFeedback } from 'context/snackbarFeedback'
import { TYPES_ALERTS } from 'utils/constants/global'

const modalFullStyles = {
  content: {
    border: '0',
    borderRadius: '0',
    bottom: '0',
    left: '0',
    padding: '0',
    right: '0',
    top: '0',
  },
  overlay: {
    zIndex: 12,
  },
}

const {
  ADD_NEW_STUDENT,
  SET_NEW_STUDENT_SCHOOL,
  SET_NEW_STUDENT_CLASSROOM,
  SET_NEW_STUDENT_COURSE,
} = steps

const StudentAddModal = () => {
  const addFeedback = useSnackBarFeedback()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { step } = useSelector(({ students }) => students)
  const [forceFetching, setForceFetching] = useState(false)

  const handleCancelNewStudent = async () => {
    await dispatch(setStepAction())
    dispatch(deleteNewStudentAction(forceFetching))
    setForceFetching(false)
  }

  const handleSubmitAddStudent = async (params) => {
    const { name } = params
    try {
      setForceFetching(true)
      addFeedback({
        dataTestId: 'success-feedback-add-student',
        id: 'success-feedback-add-student',
        text: t('La cuenta de {{studentName}} ha sido creada correctamente', {
          studentName: name,
        }),
        variant: TYPES_ALERTS.SUCCESS,
      })
    } catch (error) {
      handleCancelNewStudent()
      addFeedback({
        dataTestId: 'error-feedback-add-student',
        id: 'error-feedback-add-student',
        text: t('Ha ocurrido un problema'),
        variant: TYPES_ALERTS.ERROR,
      })
    }
  }

  const handleSubmitSetSchool = async (params) => {
    try {
      await dispatch(setSchoolAction(params))
      setForceFetching(true)
      dispatch(setStepAction(SET_NEW_STUDENT_COURSE))
    } catch {
      handleCancelNewStudent()
    }
  }

  const handleSubmitSetCourse = async (params) => {
    try {
      await dispatch(setCourseAction(params))
      dispatch(setStepAction(SET_NEW_STUDENT_CLASSROOM))
      setForceFetching(true)
    } catch {
      handleCancelNewStudent()
    }
  }

  const handleSubmitSetClassroom = async (params) => {
    await dispatch(setClassroomAction(params))
    setForceFetching(true)
    handleCancelNewStudent()
  }

  const handleRenderSchoolCode = () => {
    return (
      <ModalSchoolCodeStudent
        closeModal={handleCancelNewStudent}
        onSubmit={handleSubmitSetSchool}
      />
    )
  }

  const handleRenderSelectCourse = () => {
    return (
      <CourseForm
        onCancel={handleCancelNewStudent}
        onSubmit={handleSubmitSetCourse}
      />
    )
  }

  const handleRenderSelectGroup = () => {
    return (
      <ClassroomForm
        onCancel={handleCancelNewStudent}
        onSubmit={handleSubmitSetClassroom}
      />
    )
  }

  return (
    !!step && (
      <Modal isOpen style={modalFullStyles}>
        {step === ADD_NEW_STUDENT && (
          <StudentAddForm
            onCancel={handleCancelNewStudent}
            onSubmit={handleSubmitAddStudent}
          />
        )}
        {step === SET_NEW_STUDENT_COURSE && handleRenderSelectCourse()}
        {step === SET_NEW_STUDENT_CLASSROOM && handleRenderSelectGroup()}
        {step === SET_NEW_STUDENT_SCHOOL && handleRenderSchoolCode()}
      </Modal>
    )
  )
}

export default StudentAddModal
